import Vue from 'vue';
import Vuex from 'vuex';
// import VuexPersistence from 'vuex-persist';
import createMutationsSharer from 'vuex-shared-mutations';

import app from '@motionelements/core/src/store/modules/app.js'; // migrate site to app
import browser from '@motionelements/core/src/store/modules/browser.js';
import user from '@motionelements/core/src/store/modules/user.js';
import route from '@motionelements/core/src/store/modules/route.js';
import cart from '@motionelements/core/src/store/modules/cart.js';
import notification from '@motionelements/core/src/store/modules/notification.js';
import modal from '@motionelements/core/src/store/modules/modal.js';
import cookie from '@motionelements/core/src/store/modules/cookie.js';
import blocker from '@motionelements/core/src/store/modules/blocker.js';
import audioPlayer from '@motionelements/core/src/store/modules/audioPlayer.js';
import videoPlayer from '@motionelements/core/src/store/modules/videoPlayer.js';
import vuexSharedMutations from '@motionelements/core/src/helpers/vuexSharedMutations.js';
// import favorites from '@motionelements/core/src/store/modules/favorites.js'; // display favorites

// import searchBox from '@motionelements/core/src/store/modules/search-box'; // search history support move to search box

// import product from './modules/product';
// import payment from './modules/payment';

// import search from './modules/search/search';
// import library from './modules/library';
// import credits from './modules/credits';
// import subscription from './modules/subscription';

import {
  persistAccount,
  persistCurrency,
} from '@/store/persists';


const mutationSharer = createMutationsSharer({
  predicate: [
    'user/setJwtId',
    'user/setMember',
    'user/setLanguage',
    'user/setCurrencies',
    ...vuexSharedMutations,
  ],
});

// eslint-disable-next-line no-unused-vars
const useVuexPersistence = process.env.VUE_APP_ENV !== 'production';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    // site,
    app,
    browser,
    blocker,
    cookie,
    route,
    cart,
    audioPlayer,
    videoPlayer,

    // searchBox,
    // member,
    modal,
    user,
    // product,
    // search,
    // payment,
    // favorites,
    // library,
    // credits,
    // subscription,
    notification,
  },
  // toggle vue persist on and off
  plugins: useVuexPersistence ? [
    mutationSharer,
    persistAccount.plugin,
    persistCurrency.plugin,
  ] : [],
});
